import { Api } from "@/api";
import { ProductType, PaginationType, UserLoginType } from "@/DTO";
import { ConvertToProductType } from "@/api/product/get";
import { ConvertToPaginationType } from "@/api/help";

export const GetProductList = (user: UserLoginType, pagination: PaginationType, search?: string) => {
  return new Promise<{
    data: ProductType[]
    pagination: PaginationType
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `product/admin`,
      params: {
        page: pagination.currentPage,
        per_page: pagination.perPage,
        name: search
      },
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToAdminListType(data.data),
          pagination: ConvertToPaginationType(data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToAdminListType = (data: any[]): ProductType[] => {
  const returnData = data.map((item) => {
    return ConvertToProductType(item);
  });
  return returnData;
};

